export const updateFileStatus = (fileId, newStatus, carrom) => {
  carrom?.setHoldFile(prevHoldFile => {
    return prevHoldFile.map(file => {
      if (parseInt(file?.id) === fileId) {
        return { ...file, uploadStatus: newStatus }
      } else {
        return file
      }
    })
  })
}

export const hexToGbr = hex => {
  hex = hex.replace('#', '')
  const bigint = parseInt(hex, 16)
  const g = (bigint >> 16) & 255
  const b = (bigint >> 8) & 255
  const r = bigint & 255
  return `(${g}, ${b}, ${r})`
}

export const isValidImageType = file => {
  const acceptedImageTypes = [
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    'image/svg+xml'
  ]
  return acceptedImageTypes.includes(file.type)
}
export const validateFileContent = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = function (e) {
      const isValidImageContent = isImage(e.target.result)
      if (!isValidImageContent) {
        reject('The selected file is not a valid image.')
      } else {
        resolve(true)
      }
    }
    reader.onerror = function () {
      reject('Error reading file.')
    }
    reader.readAsArrayBuffer(file)
  })
}
// export function isImage (fileContents) {
//   // Check the magic number (file signature) to identify image files
//   const uint = new Uint8Array(fileContents)
//   if (uint.length < 4) return false

//   const hexSignature = uint.subarray(0, 4)
//     .map(b => b.toString(16).padStart(2, '0'))
//     .join('')
//     .toUpperCase()

//   const imageSignatures = [
//     'FFD8', // JPEG
//     '8950', // PNG
//     '4749'  // GIF
//   ]

//   return imageSignatures.some(signature => hexSignature.startsWith(signature))
// }

export function isImage (fileContents) {
  const uint = new Uint8Array(fileContents)
  if (uint.length < 4) return false

  const hexSignature = uint
    .subarray(0, 4)
    .map(b => b.toString(16).padStart(2, '0'))
    .join('')
    .toUpperCase()

  const imageSignatures = [
    'FFD8', // JPEG
    'FFD8FF',
    '8950', // PNG
    '4749', // GIF
    '424D', // BMP
    '4949', // TIFF (Little Endian)
    '4D4D', // TIFF (Big Endian)
    '52494646', // WebP (RIFF)
    '0000' //jpg
  ]

  if (imageSignatures.some(signature => hexSignature.startsWith(signature))) {
    return true
  }

  // Check for SVG
  const textContent = new TextDecoder().decode(fileContents)
  if (
    textContent.trim().startsWith('<svg') ||
    textContent.trim().startsWith('<?xml')
  ) {
    return true
  }

  return false
}

export function getBase64Image (img) {
  var canvas = document.createElement('canvas')
  canvas.width = img.width
  canvas.height = img.height
  var ctx = canvas.getContext('2d')
  ctx.drawImage(img, 0, 0)
  var dataURL = canvas.toDataURL('image/png')
  return dataURL.replace(/^data:image\/?[A-z]*;base64,/)
}
